"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCitizenshipList = exports.countryResidenceList = void 0;
/**************************
 * COUNTRIES OF RESIDENCE *
 **************************/
exports.countryResidenceList = [
    {
        value: "252",
        label: "Afghanistan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "401",
        label: "Aland Island",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "081",
        label: "Albania",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "131",
        label: "Algeria",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "082",
        label: "Andorra",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "151",
        label: "Angola",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "620",
        label: "Anguilla",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "621",
        label: "Antigua And Barbuda",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "703",
        label: "Argentina",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "049",
        label: "Armenia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "658",
        label: "Aruba",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "305",
        label: "Australia",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "011",
        label: "Austria",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "050",
        label: "Azerbaijan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "622",
        label: "Bahamas",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "253",
        label: "Bahrain",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "412",
        label: "Bailwick of Jersey",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "212",
        label: "Bangladesh",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "610",
        label: "Barbados",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "051",
        label: "Belarus",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "012",
        label: "Belgium",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "541",
        label: "Belize",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "160",
        label: "Benin",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "601",
        label: "Bermuda",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "254",
        label: "Bhutan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "751",
        label: "Bolivia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "402",
        label: "Bonaire, Sint Eustatius, Saba",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "048",
        label: "Bosnia and Herzegovina",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "153",
        label: "Botswana",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "403",
        label: "Bouvet Island",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "709",
        label: "Brazil",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "404",
        label: "British Indian Ocean Territory",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "633",
        label: "British Virgin Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "255",
        label: "Brunei Darussalam",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "083",
        label: "Bulgaria",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "188",
        label: "Burkina Faso",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "241",
        label: "Burma (Myanmar)",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "154",
        label: "Burundi",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "911",
        label: "Cabo Verde",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "256",
        label: "Cambodia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "155",
        label: "Cameroon",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "511",
        label: "Canada",
        medicalExamRequired: false,
        biometricsRequired: false,
    },
    {
        value: "039",
        label: "Canary Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "624",
        label: "Cayman Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "157",
        label: "Central African Republic",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "156",
        label: "Chad",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "009",
        label: "Channel Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "721",
        label: "Chile",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "202",
        label: "China",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "200",
        label: "China (Hong Kong SAR)",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "198",
        label: "China (Macao SAR)",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "405",
        label: "Christmas Island",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "722",
        label: "Colombia",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "905",
        label: "Comoros",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "840",
        label: "Cook Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "542",
        label: "Costa Rica",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "043",
        label: "Croatia",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "650",
        label: "Cuba",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "406",
        label: "Curaçao",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "221",
        label: "Cyprus",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "015",
        label: "Czech Republic",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "014",
        label: "Czechoslovakia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "158",
        label: "Democratic Rep. of Congo",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "017",
        label: "Denmark",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "183",
        label: "Djibouti",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "625",
        label: "Dominica",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "651",
        label: "Dominican Republic",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "916",
        label: "East Timor",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "753",
        label: "Ecuador",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "101",
        label: "Egypt",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "543",
        label: "El Salvador",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "002",
        label: "England",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "178",
        label: "Equatorial Guinea",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "162",
        label: "Eritrea",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "018",
        label: "Estonia",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "161",
        label: "Ethiopia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "912",
        label: "Falkland Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "912",
        label: "Faroe Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "835",
        label: "Federated States of Micronesia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "801",
        label: "Fiji",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "021",
        label: "Finland",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "821",
        label: "Fr. South. and Antarctic Lands",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "022",
        label: "France",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "754",
        label: "French Guiana",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "845",
        label: "French Polynesia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "163",
        label: "Gabon",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "164",
        label: "Gambia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "052",
        label: "Georgia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "024",
        label: "Germany, Federal Republic Of",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "165",
        label: "Ghana",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "084",
        label: "Gibraltar",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "025",
        label: "Greece",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "521",
        label: "Greenland",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "626",
        label: "Grenada",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "653",
        label: "Guadeloupe",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "832",
        label: "Guam",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "544",
        label: "Guatemala",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "409",
        label: "Guernsey",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "166",
        label: "Guinea",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "167",
        label: "Guinea-Bissau",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "711",
        label: "Guyana",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "654",
        label: "Haiti",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "410",
        label: "Heard and MacDonald Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "545",
        label: "Honduras",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "204",
        label: "Hong Kong",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "026",
        label: "Hungary",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "085",
        label: "Iceland",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "205",
        label: "India",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "222",
        label: "Indonesia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "223",
        label: "Iran",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "224",
        label: "Iraq",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "027",
        label: "Ireland",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "411",
        label: "Isle of Man",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "206",
        label: "Israel",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "028",
        label: "Italy",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "169",
        label: "Ivory Coast",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "602",
        label: "Jamaica",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "207",
        label: "Japan",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "225",
        label: "Jordan",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "053",
        label: "Kazakhstan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "132",
        label: "Kenya",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "831",
        label: "Kiribati",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "257",
        label: "Korea, North (DPRK)",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "258",
        label: "Korea, South",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "064",
        label: "Kosovo",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "226",
        label: "Kuwait",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "054",
        label: "Kyrgyzstan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "260",
        label: "Laos",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "019",
        label: "Latvia",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "208",
        label: "Lebanon",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "152",
        label: "Lesotho",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "170",
        label: "Liberia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "171",
        label: "Libya",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "086",
        label: "Liechtenstein",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "020",
        label: "Lithuania",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "013",
        label: "Luxembourg",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "261",
        label: "Macao",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "070",
        label: "Macedonia",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "172",
        label: "Madagascar",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "036",
        label: "Madeira",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "111",
        label: "Malawi",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "242",
        label: "Malaysia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "901",
        label: "Maldives",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "173",
        label: "Mali",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "030",
        label: "Malta",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "834",
        label: "Marshall Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "655",
        label: "Martinique",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "174",
        label: "Mauritania",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "902",
        label: "Mauritius",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "906",
        label: "Mayotte",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "501",
        label: "Mexico",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "055",
        label: "Moldova",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "087",
        label: "Monaco",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "262",
        label: "Mongolia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "063",
        label: "Montenegro",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "627",
        label: "Montserrat",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "133",
        label: "Morocco",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "175",
        label: "Mozambique",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "122",
        label: "Namibia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "341",
        label: "Nauru",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "264",
        label: "Nepal",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "652",
        label: "Netherlands Antilles, The",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "031",
        label: "Netherlands, The",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "628",
        label: "Nevis",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "822",
        label: "New Caledonia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "339",
        label: "New Zealand",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "546",
        label: "Nicaragua",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "176",
        label: "Niger",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "177",
        label: "Nigeria",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "414",
        label: "Niue",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "006",
        label: "Northern Ireland",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "830",
        label: "Northern Mariana Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "032",
        label: "Norway",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "263",
        label: "Oman",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "209",
        label: "Pakistan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "213",
        label: "Palestinian Authority",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "547",
        label: "Panama",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "342",
        label: "Papua New Guinea",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "755",
        label: "Paraguay",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "723",
        label: "Peru",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "227",
        label: "Philippines",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "842",
        label: "Pitcairn Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "033",
        label: "Poland",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "034",
        label: "Portugal",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "656",
        label: "Puerto Rico",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "265",
        label: "Qatar",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "159",
        label: "Republic of Congo",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "836",
        label: "Republic of Palau",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "903",
        label: "Réunion",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "088",
        label: "Romania",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "056",
        label: "Russia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "179",
        label: "Rwanda",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "915",
        label: "Saint Helena",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "629",
        label: "Saint Kitts and Nevis",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "630",
        label: "Saint Lucia",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "531",
        label: "Saint Pierre and Miquelon",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "407",
        label: "Saint-Barthelemy",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "415",
        label: "Saint-Martin",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "844",
        label: "Samoa",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "843",
        label: "Samoa, American",
        medicalExamRequired: false,
        biometricsRequired: false,
    },
    {
        value: "089",
        label: "San Marino",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "914",
        label: "Sao Tome and Principe",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "231",
        label: "Saudi Arabia",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "007",
        label: "Scotland",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "180",
        label: "Senegal",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "061",
        label: "Serbia And Montenegro",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "062",
        label: "Serbia, Republic Of",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "904",
        label: "Seychelles",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "181",
        label: "Sierra Leone",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "246",
        label: "Singapore",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "416",
        label: "Sint-Maarten",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "016",
        label: "Slovakia",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "047",
        label: "Slovenia",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "824",
        label: "Solomon Islands",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "182",
        label: "Somalia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "121",
        label: "South Africa, Republic Of",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "189",
        label: "South Sudan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "037",
        label: "Spain",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "201",
        label: "Sri Lanka",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "631",
        label: "St. Vincent and the Grenadines",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "185",
        label: "Sudan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "752",
        label: "Suriname",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "186",
        label: "Swaziland",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "040",
        label: "Sweden",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "041",
        label: "Switzerland",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "210",
        label: "Syria",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "203",
        label: "Taiwan",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "057",
        label: "Tajikistan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "130",
        label: "Tanzania",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "267",
        label: "Thailand",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "268",
        label: "Tibet (Autonomous Region)",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "187",
        label: "Togo",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "417",
        label: "Tokelau",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "846",
        label: "Tonga",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "605",
        label: "Trinidad and Tobago",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "135",
        label: "Tunisia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "045",
        label: "Turkey",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "058",
        label: "Turkmenistan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "632",
        label: "Turks and Caicos Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "826",
        label: "Tuvalu",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "418",
        label: "U.S. Minor outlying Islands",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "136",
        label: "Uganda",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "059",
        label: "Ukraine",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "042",
        label: "Union Of Soviet Socialist Rep",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "280",
        label: "United Arab Emirates",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "461",
        label: "United States of America",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "724",
        label: "Uruguay",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "060",
        label: "Uzbekistan",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "823",
        label: "Vanuatu",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "090",
        label: "Vatican City State",
        medicalExamRequired: false,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "725",
        label: "Venezuela",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "270",
        label: "Vietnam",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "657",
        label: "Virgin Islands, U.S.",
        medicalExamRequired: false,
        biometricsRequired: true,
    },
    {
        value: "008",
        label: "Wales",
        medicalExamRequired: true,
        biometricsRequired: true,
        visaExempt: true,
    },
    {
        value: "841",
        label: "Wallis and Futuna Is., Terr.",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "184",
        label: "Western Sahara",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "273",
        label: "Yemen",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "044",
        label: "Yugoslavia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "112",
        label: "Zambia",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
    {
        value: "113",
        label: "Zimbabwe",
        medicalExamRequired: true,
        biometricsRequired: true,
    },
];
exports.countryCitizenshipList = [
    {
        value: "252",
        label: "Afghanistan",
    },
    {
        value: "081",
        label: "Albania",
    },
    {
        value: "131",
        label: "Algeria",
    },
    {
        value: "082",
        label: "Andorra",
    },
    {
        value: "151",
        label: "Angola",
    },
    {
        value: "621",
        label: "Antigua And Barbuda",
    },
    {
        value: "703",
        label: "Argentina",
    },
    {
        value: "049",
        label: "Armenia",
    },
    {
        value: "305",
        label: "Australia",
    },
    {
        value: "011",
        label: "Austria",
    },
    {
        value: "050",
        label: "Azerbaijan",
    },
    {
        value: "622",
        label: "Bahamas",
    },
    {
        value: "253",
        label: "Bahrain",
    },
    {
        value: "212",
        label: "Bangladesh",
    },
    {
        value: "610",
        label: "Barbados",
    },
    {
        value: "051",
        label: "Belarus",
    },
    {
        value: "012",
        label: "Belgium",
    },
    {
        value: "541",
        label: "Belize",
    },
    {
        value: "160",
        label: "Benin",
    },
    {
        value: "254",
        label: "Bhutan",
    },
    {
        value: "751",
        label: "Bolivia",
    },
    {
        value: "048",
        label: "Bosnia and Herzegovina",
    },
    {
        value: "153",
        label: "Botswana",
    },
    {
        value: "709",
        label: "Brazil",
    },
    {
        value: "255",
        label: "Brunei Darussalam",
    },
    {
        value: "083",
        label: "Bulgaria",
    },
    {
        value: "188",
        label: "Burkina Faso",
    },
    {
        value: "241",
        label: "Burma (Myanmar)",
    },
    {
        value: "154",
        label: "Burundi",
    },
    {
        value: "911",
        label: "Cabo Verde",
    },
    {
        value: "256",
        label: "Cambodia",
    },
    {
        value: "155",
        label: "Cameroon",
    },
    {
        value: "511",
        label: "Canada",
    },
    {
        value: "157",
        label: "Central African Republic",
    },
    {
        value: "156",
        label: "Chad",
    },
    {
        value: "721",
        label: "Chile",
    },
    {
        value: "202",
        label: "China",
    },
    {
        value: "200",
        label: "China (Hong Kong SAR)",
    },
    {
        value: "198",
        label: "China (Macao SAR)",
    },
    {
        value: "722",
        label: "Colombia",
    },
    {
        value: "905",
        label: "Comoros",
    },
    {
        value: "542",
        label: "Costa Rica",
    },
    {
        value: "043",
        label: "Croatia",
    },
    {
        value: "650",
        label: "Cuba",
    },
    {
        value: "221",
        label: "Cyprus",
    },
    {
        value: "015",
        label: "Czech Republic",
    },
    {
        value: "158",
        label: "Democratic Rep. of Congo",
    },
    {
        value: "017",
        label: "Denmark",
    },
    {
        value: "183",
        label: "Djibouti",
    },
    {
        value: "625",
        label: "Dominica",
    },
    {
        value: "651",
        label: "Dominican Republic",
    },
    {
        value: "916",
        label: "East Timor",
    },
    {
        value: "753",
        label: "Ecuador",
    },
    {
        value: "101",
        label: "Egypt",
    },
    {
        value: "543",
        label: "El Salvador",
    },
    {
        value: "178",
        label: "Equatorial Guinea",
    },
    {
        value: "162",
        label: "Eritrea",
    },
    {
        value: "018",
        label: "Estonia",
    },
    {
        value: "161",
        label: "Ethiopia",
    },
    {
        value: "835",
        label: "Federated States of Micronesia",
    },
    {
        value: "801",
        label: "Fiji",
    },
    {
        value: "021",
        label: "Finland",
    },
    {
        value: "022",
        label: "France",
    },
    {
        value: "163",
        label: "Gabon",
    },
    {
        value: "164",
        label: "Gambia",
    },
    {
        value: "052",
        label: "Georgia",
    },
    {
        value: "024",
        label: "Germany, Federal Republic Of",
    },
    {
        value: "165",
        label: "Ghana",
    },
    {
        value: "025",
        label: "Greece",
    },
    {
        value: "626",
        label: "Grenada",
    },
    {
        value: "544",
        label: "Guatemala",
    },
    {
        value: "166",
        label: "Guinea",
    },
    {
        value: "167",
        label: "Guinea-Bissau",
    },
    {
        value: "711",
        label: "Guyana",
    },
    {
        value: "654",
        label: "Haiti",
    },
    {
        value: "545",
        label: "Honduras",
    },
    {
        value: "026",
        label: "Hungary",
    },
    {
        value: "085",
        label: "Iceland",
    },
    {
        value: "205",
        label: "India",
    },
    {
        value: "222",
        label: "Indonesia",
    },
    {
        value: "223",
        label: "Iran",
    },
    {
        value: "224",
        label: "Iraq",
    },
    {
        value: "027",
        label: "Ireland",
    },
    {
        value: "206",
        label: "Israel",
    },
    {
        value: "028",
        label: "Italy",
    },
    {
        value: "169",
        label: "Ivory Coast",
    },
    {
        value: "602",
        label: "Jamaica",
    },
    {
        value: "207",
        label: "Japan",
    },
    {
        value: "225",
        label: "Jordan",
    },
    {
        value: "053",
        label: "Kazakhstan",
    },
    {
        value: "132",
        label: "Kenya",
    },
    {
        value: "831",
        label: "Kiribati",
    },
    {
        value: "257",
        label: "Korea, North (DPRK)",
    },
    {
        value: "258",
        label: "Korea, South",
    },
    {
        value: "064",
        label: "Kosovo",
    },
    {
        value: "226",
        label: "Kuwait",
    },
    {
        value: "054",
        label: "Kyrgyzstan",
    },
    {
        value: "260",
        label: "Laos",
    },
    {
        value: "019",
        label: "Latvia",
    },
    {
        value: "208",
        label: "Lebanon",
    },
    {
        value: "152",
        label: "Lesotho",
    },
    {
        value: "170",
        label: "Liberia",
    },
    {
        value: "171",
        label: "Libya",
    },
    {
        value: "086",
        label: "Liechtenstein",
    },
    {
        value: "020",
        label: "Lithuania",
    },
    {
        value: "013",
        label: "Luxembourg",
    },
    {
        value: "070",
        label: "Macedonia",
    },
    {
        value: "172",
        label: "Madagascar",
    },
    {
        value: "111",
        label: "Malawi",
    },
    {
        value: "242",
        label: "Malaysia",
    },
    {
        value: "901",
        label: "Maldives",
    },
    {
        value: "173",
        label: "Mali",
    },
    {
        value: "030",
        label: "Malta",
    },
    {
        value: "834",
        label: "Marshall Islands",
    },
    {
        value: "174",
        label: "Mauritania",
    },
    {
        value: "902",
        label: "Mauritius",
    },
    {
        value: "501",
        label: "Mexico",
    },
    {
        value: "055",
        label: "Moldova",
    },
    {
        value: "087",
        label: "Monaco",
    },
    {
        value: "262",
        label: "Mongolia",
    },
    {
        value: "063",
        label: "Montenegro",
    },
    {
        value: "133",
        label: "Morocco",
    },
    {
        value: "175",
        label: "Mozambique",
    },
    {
        value: "122",
        label: "Namibia",
    },
    {
        value: "341",
        label: "Nauru",
    },
    {
        value: "264",
        label: "Nepal",
    },
    {
        value: "031",
        label: "Netherlands, The",
    },
    {
        value: "822",
        label: "New Caledonia",
    },
    {
        value: "339",
        label: "New Zealand",
    },
    {
        value: "546",
        label: "Nicaragua",
    },
    {
        value: "176",
        label: "Niger",
    },
    {
        value: "177",
        label: "Nigeria",
    },
    {
        value: "830",
        label: "Northern Mariana Islands",
    },
    {
        value: "032",
        label: "Norway",
    },
    {
        value: "263",
        label: "Oman",
    },
    {
        value: "209",
        label: "Pakistan",
    },
    {
        value: "213",
        label: "Palestinian Authority",
    },
    {
        value: "547",
        label: "Panama",
    },
    {
        value: "342",
        label: "Papua New Guinea",
    },
    {
        value: "755",
        label: "Paraguay",
    },
    {
        value: "723",
        label: "Peru",
    },
    {
        value: "227",
        label: "Philippines",
    },
    {
        value: "033",
        label: "Poland",
    },
    {
        value: "034",
        label: "Portugal",
    },
    {
        value: "265",
        label: "Qatar",
    },
    {
        value: "159",
        label: "Republic of Congo",
    },
    {
        value: "836",
        label: "Republic of Palau",
    },
    {
        value: "088",
        label: "Romania",
    },
    {
        value: "056",
        label: "Russia",
    },
    {
        value: "179",
        label: "Rwanda",
    },
    {
        value: "629",
        label: "Saint Kitts and Nevis",
    },
    {
        value: "630",
        label: "Saint Lucia",
    },
    {
        value: "844",
        label: "Samoa",
    },
    {
        value: "089",
        label: "San Marino",
    },
    {
        value: "914",
        label: "Sao Tome and Principe",
    },
    {
        value: "231",
        label: "Saudi Arabia",
    },
    {
        value: "180",
        label: "Senegal",
    },
    {
        value: "062",
        label: "Serbia, Republic Of",
    },
    {
        value: "904",
        label: "Seychelles",
    },
    {
        value: "181",
        label: "Sierra Leone",
    },
    {
        value: "246",
        label: "Singapore",
    },
    {
        value: "016",
        label: "Slovakia",
    },
    {
        value: "047",
        label: "Slovenia",
    },
    {
        value: "824",
        label: "Solomon Islands",
    },
    {
        value: "182",
        label: "Somalia",
    },
    {
        value: "121",
        label: "South Africa, Republic Of",
    },
    {
        value: "189",
        label: "South Sudan",
    },
    {
        value: "037",
        label: "Spain",
    },
    {
        value: "201",
        label: "Sri Lanka",
    },
    {
        value: "631",
        label: "St. Vincent and the Grenadines",
    },
    {
        value: "979",
        label: "Stateless",
    },
    {
        value: "185",
        label: "Sudan",
    },
    {
        value: "752",
        label: "Suriname",
    },
    {
        value: "186",
        label: "Swaziland",
    },
    {
        value: "040",
        label: "Sweden",
    },
    {
        value: "041",
        label: "Switzerland",
    },
    {
        value: "210",
        label: "Syria",
    },
    {
        value: "203",
        label: "Taiwan",
    },
    {
        value: "057",
        label: "Tajikistan",
    },
    {
        value: "130",
        label: "Tanzania",
    },
    {
        value: "267",
        label: "Thailand",
    },
    {
        value: "187",
        label: "Togo",
    },
    {
        value: "846",
        label: "Tonga",
    },
    {
        value: "605",
        label: "Trinidad and Tobago",
    },
    {
        value: "135",
        label: "Tunisia",
    },
    {
        value: "045",
        label: "Turkey",
    },
    {
        value: "058",
        label: "Turkmenistan",
    },
    {
        value: "826",
        label: "Tuvalu",
    },
    {
        value: "136",
        label: "Uganda",
    },
    {
        value: "010",
        label: "UK - Brit. Ntl. Overseas",
    },
    {
        value: "004",
        label: "UK - Brit. overseas citizen",
    },
    {
        value: "005",
        label: "UK - Brit. overseas terr.",
    },
    {
        value: "003",
        label: "UK - British citizen",
    },
    {
        value: "059",
        label: "Ukraine",
    },
    {
        value: "280",
        label: "United Arab Emirates",
    },
    {
        value: "461",
        label: "United States of America",
    },
    {
        value: "000",
        label: "Unknown",
    },
    {
        value: "724",
        label: "Uruguay",
    },
    {
        value: "060",
        label: "Uzbekistan",
    },
    {
        value: "823",
        label: "Vanuatu",
    },
    {
        value: "090",
        label: "Vatican City State",
    },
    {
        value: "725",
        label: "Venezuela",
    },
    {
        value: "270",
        label: "Vietnam",
    },
    {
        value: "184",
        label: "Western Sahara",
    },
    {
        value: "273",
        label: "Yemen",
    },
    {
        value: "112",
        label: "Zambia",
    },
    {
        value: "113",
        label: "Zimbabwe",
    },
];
